import { Injectable } from "@angular/core";
import { OrderManagementResolver } from "../Managment/orderManagement/orderManagement.resolver";
import { UserViewResolver } from "./user-view.resolver";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { OrderManagementConfig, UserViewConfig } from "../../objects/users/user";
import { Dictionary } from "lodash";
import { SearchResponse } from "../../objects/responses/searchResponse";
import { Order } from "../../objects/orders/order";


@Injectable()
export class UserViewOrderResolver implements Resolve<{userViewConfig: Dictionary<OrderManagementConfig>, orders: SearchResponse<Order>}>{
    constructor(
        protected orderManagementResolver: OrderManagementResolver,
        protected userViewResolver: UserViewResolver){};

    public async resolve(route: ActivatedRouteSnapshot): Promise<{userViewConfig: Dictionary<OrderManagementConfig>, orders: SearchResponse<Order>}>{
        const userViewConfig = await this.userViewResolver.resolve(route);
        const orders = await this.orderManagementResolver.resolve(route);

        return {userViewConfig, orders};
    }
}


// WEBPACK FOOTER //
// ./app/components/userView/user-view-order.resolver.ts